import http from '../../services/http';

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('BusinessNameGenerator', (csrfToken, formAction) => ({
        businessName: '',
        businessNameCopy: '',
        csrfToken,
        formAction,
        showMessage: false,
        limit: 18,
        message: '',
        success: false,
        loading: false,
        generatedNames: [],
        error: '',
        async validateText() {
          let values = null;
          const regex = /^[a-zA-Z0-9 &]*$/;

          try {
            if (
              this.businessName.length > 50 ||
              this.businessName === '' ||
              !regex.test(this.businessName)
            ) {
              values = { status: 203, error: '' };
              if (this.businessName === '') {
                values.error = 'Please enter a keyword to generate names.';
              }
              if (this.businessName.length > 50) {
                values.error = 'The character limit is 50.';
              }

              if (!regex.test(this.businessName)) {
                values.error =
                  'Only alphanumeric characters, spaces, and the & symbol are allowed.';
              }
              this.error = values.error;
              this.loading = false;
            } else {
              this.error = '';
              values = await http.post(
                this.formAction,
                {
                  business_name: this.businessName,
                },
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                  },
                },
              );
            }
            return values;
          } catch (error) {
            this.displayMessage(
              'An error occurred while generating a business name.',
              false,
            );
          }
        },
        async submitForm() {
          this.loading = true;
          this.businessNameCopy = this.businessName;
          this.generatedNames = [];
          const response = await this.validateText();

          try {
            if (response.status === 200 && response.data) {
              this.error = '';
              const generatedNameObj =
                response.data.data.data || 'No name generated.';
              this.generatedNames = generatedNameObj.map((item) => item.name);
              this.businessName = '';
              this.loading = false;
              const elementPosition =
                document
                  .getElementById('business-name-generator-form')
                  .getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({
                top: elementPosition,
                behavior: 'smooth',
              });
            } else {
              this.displayMessage(
                'Failed to generate a business name. Please try again.',
                false,
              );
            }
          } catch (error) {
            this.displayMessage(
              'An error occurred while generating a business name.',
              false,
            );
          }
        },

        resetNames() {
          this.generatedNames = [];
          this.limit = 18;
          this.businessName = '';
          this.businessNameCopy = '';
          window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        showAll() {
          this.limit = 30;
        },

        displayMessage(text, isSuccess) {
          this.message = text;
          this.success = isSuccess;
          this.showMessage = true;

          setTimeout(() => {
            this.showMessage = false;
          }, 5000);
        },
      }));
    });
  },
};
